export default "__VITE_ASSET__YQo2VXeG__"